import React from "react";
import UnhideBookSvg from '@/assets/icons/unhide.svg?react';

interface UnhideBookIconProps {
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
}

const UnhideBookIcon: React.FC<UnhideBookIconProps> = ({
  size = "md",
  color = "currentColor",
  className = "",
}) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
  };

  return (
    <UnhideBookSvg
      fill={color}
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

export default UnhideBookIcon;
